var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMailOne(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M491,176.2L261.3,334.6c-1.6,1.1-3.5,1.7-5.3,1.7s-3.7-0.6-5.3-1.7L21,176.2c-9.1,7.2-15,18.3-15,30.9v239.7   c0,21.7,17.6,39.3,39.3,39.3h421.3c21.7,0,39.3-17.6,39.3-39.3V207C506,194.5,500.1,183.4,491,176.2z M187.1,330.2L71,446.3   c-0.9,0.9-2.1,1.4-3.3,1.4c-1.2,0-2.4-0.5-3.3-1.4c-1.8-1.8-1.8-4.8,0-6.6l116.1-116.1c1.8-1.8,4.8-1.8,6.6,0   C189,325.4,189,328.4,187.1,330.2z M447.6,446.3c-0.9,0.9-2.1,1.4-3.3,1.4s-2.4-0.5-3.3-1.4L324.9,330.2c-1.8-1.8-1.8-4.8,0-6.6   s4.8-1.8,6.6,0l116.1,116.1C449.4,441.5,449.4,444.5,447.6,446.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 14,
    id: "XMLID_6_",
    width: 216,
    x: 148,
    y: 209.2
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_5_",
    points: "148,241 162.3,250.9 349.7,250.9 364,241 364,236.9 148,236.9   "
  }), /*#__PURE__*/React.createElement("rect", {
    height: 14,
    id: "XMLID_4_",
    width: 216,
    x: 148,
    y: 181.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464,163.8L271,30.6c-9.1-6.2-21-6.2-30.1,0L48,163.8c-2.9,2-2.9,6.2,0,8.2l64,44.2v-77.8h288v77.8l64-44.2    C466.9,170,466.9,165.8,464,163.8z",
    id: "XMLID_3_"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_2_",
    points: "182.1,264.5 202.4,278.5 309.6,278.5 329.9,264.5   "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.8,292.2h-67.5l18.7,12.9c0.6,0.4,1.1,0.7,1.7,1.1h26.7c0.6-0.3,1.1-0.7,1.7-1.1L289.8,292.2z",
    id: "XMLID_1_"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailOne);
export default __webpack_public_path__ + "static/media/mailOne.3299480843024a2d54fe55ec90aed223.svg";
export { ForwardRef as ReactComponent };